(function () {
  var backButton = document.querySelector('[data-back-button]');
  if (!backButton) return;

  function normalizePath(path) {
    var normalized = (path || '/').toLowerCase();
    return normalized.length > 1 && normalized.endsWith('/') ? normalized.slice(0, -1) : normalized;
  }

  function isAppHomePage() {
    return backButton.dataset.homePage === 'true' || normalizePath(window.location.pathname) === normalizePath(backButton.dataset.fallback);
  }

  function updateVisibility() {
    backButton.hidden = !window.matchMedia('(max-width: 850px)').matches || isAppHomePage();
  }

  function hasSameOriginHistory() {
    if (window.history.length <= 1 || !document.referrer) return false;
    try {
      return new URL(document.referrer).origin === window.location.origin;
    } catch (error) {
      return false;
    }
  }

  backButton.addEventListener('click', function () {
    if (hasSameOriginHistory()) {
      window.history.back();
      return;
    }
    window.location.assign(backButton.dataset.fallback || '/');
  });

  updateVisibility();
  window.addEventListener('pageshow', updateVisibility);
  window.addEventListener('resize', updateVisibility);
})();
